import { BetCalculationsEnum, getBetCalculations } from "calculation";
import { IClientConfig } from "src/client-config/config";
import { BetTypeEnum } from "src/constants/enums/betType";
import { IBonusRule, ICurrencyConfig, IPartnerConfig } from "src/constants/interfaces";
import { ISelection } from "src/constants/interfaces/bet";

export const getEstimatedReturn = (
	config: IClientConfig,
	betType: BetTypeEnum,
	stake: number,
	selections: ISelection[],
	bonusRule: IBonusRule[] | undefined,
	partnerConfig?: IPartnerConfig,
	currencyConfig?: ICurrencyConfig,
) => {
	const { possibleWin, expressBonus: { amount }} = getBetCalculations([BetCalculationsEnum.PossibleWin, BetCalculationsEnum.Bonus], {
		config,
		partnerConfig,
		stake: +stake,
		events: selections,
    betType,
    bonusRule,
		currencyConfig,
	});

	return possibleWin + amount;
}